import {BillingInterval} from '~/api/types/billing'
import Country from '~/locale/country'

import type {AdditionalUsersPricing} from '../types'

/**
 * Additional user pricing plan in Sweden
 */
const ADDITIONAL_USER_PRICING_SE: Array<AdditionalUsersPricing> = [
    {
        interval: BillingInterval.MONTHLY,
        countries: [Country.SE],
        currencies: ['SEK', 'NOK'],
        withCashback: true,
        pricingTable: {
            ESSENTIAL: [
                {
                    amountOfUsers: '0-10',
                    price: 150,
                },
                {
                    amountOfUsers: '11-30',
                    price: 135,
                },

                {
                    amountOfUsers: '31-50',
                    price: 125,
                },
                {
                    amountOfUsers: '51-100',
                    price: 115,
                },
                {
                    amountOfUsers: '101-200',
                    price: 100,
                },
                {
                    amountOfUsers: '201-400',
                    price: 90,
                },
                {
                    amountOfUsers: '401-600',
                    price: 75,
                },
                {
                    amountOfUsers: '>600',
                    price: 65,
                },
            ],
            ADVANCED: [
                {
                    amountOfUsers: '0-10',
                    price: 180,
                },
                {
                    amountOfUsers: '11-30',
                    price: 165,
                },

                {
                    amountOfUsers: '31-50',
                    price: 150,
                },
                {
                    amountOfUsers: '51-100',
                    price: 135,
                },
                {
                    amountOfUsers: '101-200',
                    price: 125,
                },
                {
                    amountOfUsers: '201-400',
                    price: 115,
                },
                {
                    amountOfUsers: '401-600',
                    price: 100,
                },
                {
                    amountOfUsers: '>600',
                    price: 90,
                },
            ],
        },
    },
    {
        interval: BillingInterval.MONTHLY,
        countries: [Country.SE],
        currencies: ['SEK', 'NOK'],
        withCashback: false,
        pricingTable: {
            ESSENTIAL: [
                {
                    amountOfUsers: '0-10',
                    price: 150,
                },
                {
                    amountOfUsers: '11-30',
                    price: 135,
                },

                {
                    amountOfUsers: '31-50',
                    price: 125,
                },
                {
                    amountOfUsers: '51-100',
                    price: 115,
                },
                {
                    amountOfUsers: '101-200',
                    price: 100,
                },
                {
                    amountOfUsers: '201-400',
                    price: 90,
                },
                {
                    amountOfUsers: '401-600',
                    price: 75,
                },
                {
                    amountOfUsers: '>600',
                    price: 65,
                },
            ],
            ADVANCED: [
                {
                    amountOfUsers: '0-10',
                    price: 180,
                },
                {
                    amountOfUsers: '11-30',
                    price: 165,
                },

                {
                    amountOfUsers: '31-50',
                    price: 150,
                },
                {
                    amountOfUsers: '51-100',
                    price: 135,
                },
                {
                    amountOfUsers: '101-200',
                    price: 125,
                },
                {
                    amountOfUsers: '201-400',
                    price: 115,
                },
                {
                    amountOfUsers: '401-600',
                    price: 100,
                },
                {
                    amountOfUsers: '>600',
                    price: 90,
                },
            ],
        },
    },
    {
        interval: BillingInterval.YEARLY,
        countries: [Country.SE],
        currencies: ['SEK', 'NOK'],
        withCashback: true,
        pricingTable: {
            ESSENTIAL: [
                {
                    amountOfUsers: '0-10',
                    price: 135,
                },
                {
                    amountOfUsers: '11-30',
                    price: 125,
                },

                {
                    amountOfUsers: '31-50',
                    price: 115,
                },
                {
                    amountOfUsers: '51-100',
                    price: 100,
                },
                {
                    amountOfUsers: '101-200',
                    price: 90,
                },
                {
                    amountOfUsers: '201-400',
                    price: 85,
                },
                {
                    amountOfUsers: '401-600',
                    price: 70,
                },
                {
                    amountOfUsers: '>600',
                    price: 60,
                },
            ],
            ADVANCED: [
                {
                    amountOfUsers: '0-10',
                    price: 160,
                },
                {
                    amountOfUsers: '11-30',
                    price: 150,
                },

                {
                    amountOfUsers: '31-50',
                    price: 135,
                },
                {
                    amountOfUsers: '51-100',
                    price: 125,
                },
                {
                    amountOfUsers: '101-200',
                    price: 115,
                },
                {
                    amountOfUsers: '201-400',
                    price: 100,
                },
                {
                    amountOfUsers: '401-600',
                    price: 85,
                },
                {
                    amountOfUsers: '>600',
                    price: 75,
                },
            ],
        },
    },
]

export default ADDITIONAL_USER_PRICING_SE
